import { endpoints } from "./endpoints";
import axios from "axios";

const URL = process.env.VUE_APP_API_SERVEL;

const getAll = async (filters) => {
    const url = `${URL}${endpoints.users}`
    return axios.get(url,filters).then(response => { 
        return response.data.data;
    });
}

const getUser = async (id) => {
    const url = `${URL}${endpoints.users}/${id}`
    return axios.get(url).then(response => { 
        return response.data.data;
    });
}

 const getPermissions = async()=>{
    const url=`${URL}${endpoints.permissions}`
    return axios.get(url).then(response => { 
        return response.data.data;
    });
 }

 const getSubdirecciones=async()=>{
    const url=`${URL}${endpoints.subdirecciones}`
    return axios.get(url).then(response => { 
        return response.data.data;
    });
}
 const getDireccionesRegionales=async()=>{
    const url=`${URL}${endpoints.direccionregional}`
    return axios.get(url).then(response => { 
        return response.data.data;
    });
}

const createUser = async (data) => {
    const url = `${URL}${endpoints.users}`
    return axios.put(url,data).then(response => { 
        return response.data;
    });
}

const editUser = async (data) => {
    const url = `${URL}${endpoints.users}`
    return axios.post(url,data).then(response => { 
        return response.data;
    });
}

export const UserService = {
    getAll,
    getUser,
    getPermissions,
    getSubdirecciones,
    getDireccionesRegionales,
    createUser,
    editUser
}